import { Component } from "@angular/core";
import { PolicyHeaderComponent } from "../policy-header/policy-header.component";

@Component({
  selector: "app-aul-030-24",
  standalone: true,
  imports: [PolicyHeaderComponent],
  templateUrl: "./aul-030-24.component.html",
  styleUrl: "./aul-030-24.component.scss",
})
export class Aul03024Component {}
